export default __webpack_public_path__ + "static/media/apple_stimuli_fr_phone.ebe69545.mp4";